import React from 'react'
import GenericError from '../Generic'

const Component = () => {
  return <GenericError title="エラーが発生しました" />
}

export default Component
